import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AnyBomItemSetService } from './api/anyBomItemSet.service';
import { BatchRequestsService } from './api/batchRequests.service';
import { BomHeaderEditionSetService } from './api/bomHeaderEditionSet.service';
import { BomHeaderSetService } from './api/bomHeaderSet.service';
import { BomItemChangeSetService } from './api/bomItemChangeSet.service';
import { BomItemEditionSetService } from './api/bomItemEditionSet.service';
import { BomItemSetService } from './api/bomItemSet.service';
import { BomPermanentHeaderSetService } from './api/bomPermanentHeaderSet.service';
import { BomSubItemSetService } from './api/bomSubItemSet.service';
import { SubscriptionCollectionService } from './api/subscriptionCollection.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class BomApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<BomApiModule> {
        return {
            ngModule: BomApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: BomApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('BomApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
